.option {
  & + & {
    margin-top: 12px;
  }
}
